deleteTrackingRow=function(btn){
const tr=btn && btn.closest('tr');
if(!tr)return;
const target={
no:tr.querySelector('.t-no')?.value.trim()||'',
date:tr.querySelector('.t-date')?.value||'',
order:tr.querySelector('.t-order')?.value.trim()||'',
buyer:tr.querySelector('.t-buyer')?.value.trim()||'',
file:tr.querySelector('.t-file')?.value.trim()||''
};
const same=(r)=>
String(r.no||'').trim()===target.no &&
String(r.date||'')===target.date &&
String(r.order||'').trim()===target.order &&
String(r.buyer||'').trim()===target.buyer &&
String(r.file||'').trim()===target.file;
const rows=getTrackingInfo();
const idx=rows.findIndex(same);
if(idx>=0){
rows.splice(idx,1);
setTrackingInfo(rows);
}
tr.remove();
renderStats();
// Jei nebeliko įrašų, lentelė lieka tiesiog tuščia.
if(!getTrackingInfo().length){
const tb=document.getElementById('trackingBody');
if(tb)tb.innerHTML='';
}
};
